// extracted by mini-css-extract-plugin
module.exports = {"rankings-header":"myGiS6B9Bge3MwBYnlXo","actions":"_1VzaCdBaXtMWU1m7a5cl","is-off":"_10QgcVvIyFz73ZUeWv0n","move-arrows":"_1ZdYZA2BCvxF920R2mu-","disabled":"iR_kaDepI8Qj2J5DYh0C"};